import request from '@/utils/request'

// 退款列表
export function getRefundList(params) {
    return request({
        url: '/admin/v1/refund/list',
        method: 'get',
        params
    })
}

// 确认退款
export function getRefundConfirm(params) {
    return request({
        url: '/admin/v1/refund/pay',
        method: 'post',
        params
    })
}

// 退款详情
export function getRefundDetail(params) {
    return request({
        url: '/admin/v1/refund/info',
        method: 'get',
        params
    })
}
